import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Flex,
    IconPhoneCircle,
    IconMail,
    Spacer,
    TextButton,
} from '@zillow/constellation';

import { Col, Row } from '@zillow/zrs-comet';

import numberUtils from 'app/shared/utils/numberUtils';

import {
    StyledContainer,
    StyledIconContainer,
    StyledGrayText,
    StyledDesktopStatusText,
    StyledMobileStatusText,
    StyledWrapText,
    StyledSuccessIcon,
    StyledIconWarning,
} from './StyledComponents';

const propTypes = {
    data: PropTypes.shape({
        isVerified: PropTypes.bool.isRequired,
        value: PropTypes.string.isRequired,
        canBeRemoved: PropTypes.bool.isRequired,
    }).isRequired,
    emailVerificationText: PropTypes.string,
    inManageContactModal: PropTypes.bool,
    onDelete: PropTypes.func, // eslint-disable-line react/require-default-props
    onVerifyPhoneClick: PropTypes.func, // eslint-disable-line react/require-default-props
    onVerifyEmailClick: PropTypes.func, // eslint-disable-line react/require-default-props
};

const defaultProps = {
    emailVerificationText: 'Send verification email',
    inManageContactModal: false,
};

const ContactMethodDetail = ({
    data: { isVerified, value, canBeRemoved },
    emailVerificationText,
    inManageContactModal,
    onDelete,
    onVerifyPhoneClick,
    onVerifyEmailClick,
}) => {
    const isEmail = isNaN(parseInt(value, 10));
    const Icon = isEmail ? IconMail : IconPhoneCircle;
    const statusText = isVerified ? (
        <>
            <StyledSuccessIcon />
            Verified
        </>
    ) : (
        <>
            <StyledIconWarning />
            Not verified
        </>
    );

    const getHelpText = () => inManageContactModal && isVerified && 'A verified contact cannot be removed';

    const getCTAButton = () => {
        if (inManageContactModal) {
            return canBeRemoved ?
                <TextButton onClick={() => onDelete({ isVerified, value })}>Remove</TextButton>
                : null;
        }
        return (
            <Button
                buttonType="primary"
                onClick={() => (isEmail ? onVerifyEmailClick(value) : onVerifyPhoneClick(value))}
            >
                {isEmail ? emailVerificationText : 'Verify now'}
            </Button>
        );
    };

    return (
        <StyledContainer className="ContactMethodDetail">
            <Row>
                <Col xs={2} lg={1} noPadding={true}>
                    <StyledIconContainer>
                        <Icon fontColor="blue600" size="md" />
                    </StyledIconContainer>
                </Col>
                <Col xs={10} md={7} noPadding={true}>
                    <Flex display="flex" flexDirection="column" flexGrow={1}>
                        <StyledWrapText as="div">
                            <b>{isEmail ? value : numberUtils.formatPhoneNumberInput(value)}</b>
                        </StyledWrapText>
                        <StyledGrayText as="div">{getHelpText()}</StyledGrayText>
                        <StyledMobileStatusText>{statusText}</StyledMobileStatusText>
                        {!isVerified && (
                            <Spacer marginTop="xs">
                                {getCTAButton()}
                            </Spacer>
                        )}
                    </Flex>
                </Col>
                <Col xs={0} lg={4} noPadding={true} alignHorizontal="flex-end">
                    <StyledDesktopStatusText>
                        {statusText}
                    </StyledDesktopStatusText>
                </Col>
            </Row>
        </StyledContainer>
    );
};

ContactMethodDetail.propTypes = propTypes;
ContactMethodDetail.defaultProps = defaultProps;

export default ContactMethodDetail;
